module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component.css
// module id = ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component.css
// module chunks = main